export const VerifyCreatedDate = (data: any) => {
    let validDate = new Date("2021-12-01");
    validDate.setHours(0, 0, 0, 0);
    let createdAt = new Date(data.created);
    createdAt.setHours(0, 0, 0, 0);
    if (createdAt > validDate) return true
    else return false
}


// WEBPACK FOOTER //
// ./src/app/shared/helpers/verify-created-date.ts